



















import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IReport, Report } from "@/models/report.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, PropSync, Watch } from "vue-property-decorator";
import ClaimSettlementForm from "./ClaimSettlementForm.vue";

@Component({
  components: {
    ClaimSettlementForm,
    ConfirmActionDialog
  },
  filters: {}
})
export default class ClaimSettlementUpdateDialog extends mixins(PermissionMixin) {
  @Prop() value!: IReport;

  @PropSync("isOpen") isDialogOpen!: boolean;

  @Watch("isDialogOpen", { immediate: true, deep: true })
  setLocalCopy(isOpen: boolean) {
    if (isOpen) {
      this.localReport = new Report(this.value);
    }
  }

  loading = false;
  isValid = true;
  localReport?: IReport | null = null;

  async update() {
    this.loading = true;

    try {
      await this.localReport?.updatePartial({
        liabilitySharePercent: this.localReport.liabilitySharePercent,
        isDeductions: this.localReport.isDeductions,
        isDepreciationCredit: this.localReport.isDepreciationCredit
      });

      this.value.liabilitySharePercent = this.localReport?.liabilitySharePercent;
      this.value.isDeductions = this.localReport?.isDeductions;
      this.value.isDepreciationCredit = this.localReport?.isDepreciationCredit;

      this.isDialogOpen = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }
}
